// Module
var code = "<div id=\"V-ACD228A5-DAA5-4E13-94FC-A7932B9F9E06\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\"></div> </div> ";
// Exports
export default code;